import React, { useMemo, useState, useEffect, type ReactNode } from 'react';
import dayjs from 'dayjs';

import { useUserContext } from '../user';
import { getLanguageById } from '../../utils/language';

import LanguageContext from './context';
import { sessionTraduction, reportTraduction } from '../../services/Sessions';
import i18n from '../../assets/i18n';
interface LanguageContextProviderProps {
  children: ReactNode;
}

const LanguageContextProvider = ({ children }: LanguageContextProviderProps) => {
  const { userSession } = useUserContext();

  const [locale, setLocale] = useState('enGB');
  const [currentLanguage, setCurrentLanguage] = useState<any>();

  useEffect(() => {
    const newCurrentLanguage = getLanguageById(userSession?.language);
    const newLocale = newCurrentLanguage?.locale;

    setLocale(newLocale);
    setCurrentLanguage(newCurrentLanguage);
  }, [userSession?.language]);

  useEffect(() => {
    if (!currentLanguage) return;

    const { name } = currentLanguage;
    const language = name.toLowerCase();
    dayjs.locale(language);
    document.documentElement.lang = language;

    Promise.all([
      sessionTraduction(language),
      reportTraduction(language),
      i18n.changeLanguage(language),
    ]).then(([data1, data2]) => {
      i18n.addResourceBundle(language, 'translation', data1, true, false);
      i18n.addResourceBundle(language, 'translation', data2, true, false);
    });
  }, [currentLanguage]);

  const value = useMemo(() => ({
    locale,
    currentLanguage,
  }), [locale, currentLanguage]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
export default LanguageContextProvider;
